module.exports = __webpack_public_path__ + "static/sliver-00a7133c5f0af097981bd345c115d088.png";